import React, { Component } from 'react';
import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonSmallText from '../../../common-components/common-small-text';

const list = [
    {
        showDataTitle: '1 500+',
        showDataSubtitle: 'часов трудозатрат',
    },
    {
        showDataTitle: '200+',
        showDataSubtitle: 'концепций креативов',
    },
    {
        showDataTitle: '5 410',
        showDataSubtitle: 'лидов',
    },
    {
        showDataTitle: '100%',
        showDataSubtitle: 'kpi выполнено в каждом месяце',
    },
];

class Results extends Component {
    render() {
        return (
            <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1.5}>
                <FullWrapper className="results" smallPaddings={true}>
                    <CommonTitle>Результаты</CommonTitle>
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1.5}
                    >
                        <CommonUsualText className="results__text-info">
                            Мы не просто выполнили все KPI и уложились в сроки, мы проработали
                            проблемные места, выделили перспективные точки масштабирования
                            в проектах и сформировали по ним дорожную карту развития на весь
                            2020 год.
                        </CommonUsualText>
                    </ScrollAnimation>
                    <div className="results-ciphers">
                        <div className="results-ciphers__wrapper">
                            <div className="results-ciphers__grid">
                                {list.map(({ showDataTitle, showDataSubtitle }, index) => (
                                    <ScrollAnimation
                                        animateIn="fadeInUp"
                                        offset={0}
                                        delay={100}
                                        animateOnce={true}
                                        duration={1}
                                        className="results-ciphers__item"
                                        key={index}
                                    >
                                        <div className="results-ciphers__item-wrap">
                                            <div className="results-ciphers__name">
                                                {showDataTitle}
                                            </div>
                                            <CommonSmallText className="results-ciphers__desc">
                                                {showDataSubtitle}
                                            </CommonSmallText>
                                        </div>
                                    </ScrollAnimation>
                                ))}
                            </div>
                        </div>
                    </div>
                </FullWrapper>
            </ScrollAnimation>
        );
    }
}

export default Results;
